const point = (stop, arrival) => ({
    time: arrival ? stop.arrivalTime : stop.departureTime,
    code: arrival ? stop.arrivalAirportCode : stop.departureAirportCode,
    city: arrival ? stop.arrivalAirportCityName : stop.departureAirportCityName,
    name: arrival ? stop.arrivalAirportName : stop.departureAirportName,
    terminal: arrival ? stop.arrivalAirportTerminalName : stop.departureAirportTerminalName,
});
export function tourFlightDirection(variant, direction) {
    const stops = (direction === 'forward' ? variant.forwardStops : variant.returnStops) || [];
    if (!stops.length)
        return undefined;
    return {
        from: point(stops[0], false),
        to: point(stops[stops.length - 1], true),
        durationMinutes: direction === 'forward' ? variant.forwardFlightDuration : variant.returnFlightDuration,
        stopsCount: stops.length - 1,
        airlines: Array.from(new Set(stops.map(stop => stop.airlineName))),
        flightNumbers: stops.map(stop => stop.flightNumber),
        segments: stops.map(stop => ({
            from: point(stop, false), to: point(stop, true), flightNumber: stop.flightNumber,
            airlineName: stop.airlineName, durationMinutes: stop.flightDuration, connectionMinutes: stop.stopDuration,
        })),
    };
}
